<div class="payment-container p-4 bg-white shadow-2xl rounded-2xl max-w-lg mx-auto">
    <div class="flex justify-between items-center mb-6">
        <img src="assets/images/facturacion/logo_factura.png" class="w-32">
        <div class="card-item text-right">
            <h2 class="text-xl font-semibold text-gray-800">Paquete {{ data.folios }} Folios</h2>
            <h5 class="text-gray-500">{{ data.pof | currency }} por folio</h5>
        </div>
    </div>

    <div class="bg-gray-50 p-4 rounded-lg mb-6">
        <div class="flex justify-between items-center">
            <span class="font-semibold text-lg text-gray-700">Pago</span>
            <div class="flex space-x-2">
                <img src="https://img.icons8.com/color/48/000000/visa.png" alt="Visa" class="w-8 h-8" />
                <img src="https://img.icons8.com/color/48/000000/mastercard-logo.png" alt="Mastercard"
                    class="w-8 h-8" />
                <img src="https://img.icons8.com/color/48/000000/maestro.png" alt="Maestro" class="w-8 h-8" />
            </div>
        </div>
        <p class="text-sm text-gray-500 mt-1">Tarjeta de crédito o débito</p>
    </div>

    <!-- Mensajes dinámicos de éxito o error -->
    <div *ngIf="paymentStatus === 'success'" class="flex items-center bg-green-50 p-4 rounded-lg mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4" />
        </svg>
        <span class="text-green-600 font-medium">{{ paymentMessage }}</span>
    </div>

    <div *ngIf="paymentStatus === 'error'" class="flex items-center bg-orange-50 p-4 rounded-lg mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-orange-500 mr-2" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 16h-1v-4h1m0-4h-.01M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        </svg>
        <span class="text-orange-600 font-medium">{{ paymentMessage }}</span>
    </div>

    <form class="space-y-4">
        <div class="flex flex-col">
            <label for="cardholder-name" class="text-sm font-medium text-gray-600">Nombre del tarjetahabiente:</label>
            <input id="cardholder-name" placeholder="Ingresa tu nombre"
                class="border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
        </div>

        <div class="flex flex-col">
            <label for="card-number" class="text-sm font-medium text-gray-600">Número de tarjeta:</label>
            <div id="card" class="field border border-gray-300 rounded-lg p-2"></div>
        </div>

        <div class="flex space-x-4">
            <div class="w-1/2">
                <label for="card-expiry" class="text-sm font-medium text-gray-600">Fecha de caducidad:</label>
                <div id="cardExpiry" class="field border border-gray-300 rounded-lg p-2"></div>
            </div>
            <div class="w-1/2">
                <label for="card-cvc" class="text-sm font-medium text-gray-600">Código de seguridad:</label>
                <div id="cardCvc" class="field border border-gray-300 rounded-lg p-2"></div>
            </div>
        </div>
    </form>

    <button id="button" (click)='CreateToken()'
        class="w-full bg-blue-500 text-white py-2 mt-6 rounded-lg hover:bg-blue-600 focus:outline-none"
        *ngIf="!paymentStatus">
        Pagar MXN {{ data.amount | currency }}
    </button>

    <button *ngIf="paymentStatus === 'error'" (click)="RestoreForm()"
        class="w-full bg-orange-500 text-white py-2 mt-4 rounded-lg hover:bg-orange-600">
        Intentar con otra tarjeta
    </button>
</div>